import { render, staticRenderFns } from "./projectUpload.vue?vue&type=template&id=479916b4&scoped=true&"
import script from "./projectUpload.vue?vue&type=script&lang=js&"
export * from "./projectUpload.vue?vue&type=script&lang=js&"
import style0 from "./projectUpload.vue?vue&type=style&index=0&id=479916b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "479916b4",
  null
  
)

export default component.exports